import { Permission } from '@fabric-ui/components';
import { schema } from '@Schema/schema';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/assets/visual/')({
  validateSearch: zodValidator(schema.VISUAL_EXPLORER),

  beforeLoad: ({ context, preload }) => {
    const path = PAGE_PATHS.ASSETS;
    const isAllowed = context.userPermissions.hasAllowedPermission({ path, permission: Permission.READ });
    context.validatePermissions({ isAllowed, preload });
  },
});
